import { getServiceUrl, selectAPIService } from '@/app/_utils/select-api-service'

import { setUrlParams } from '../../_utils/set-url-params'
import { PLPPages } from '../types'

export async function getPLPBasicMetas(page: PLPPages, slug: string | [string, string]) {
    const apiService = selectAPIService()
    const ntlBaseUrl = getServiceUrl(apiService.ntl)
    const cmlBaseUrl = getServiceUrl(apiService.cml)

    let url = ''
    if (Array.isArray(slug)) {
        url = `${ntlBaseUrl}/catalog/${PLPPages.Brands}/slug/${slug[0]}/category/${slug[1]}`
    } else if (page === PLPPages.Tags) {
        url = `${cmlBaseUrl}/tags/slug/${slug}`
    } else {
        url = `${ntlBaseUrl}/catalog/${page}/slug/${slug}`
    }

    const finalUrl = setUrlParams(url)

    try {
        const response = await fetch(finalUrl, { cache: 'no-cache' })
        const result = await response.json()

        if (!response.ok) {
            if (result.errors[0].code === 'entity.not.found' || result.errors[0].code === 'record.not.found') {
                return null
            } else {
                throw new Error(`Search for ${finalUrl} failed. Status Code: ${response.status}`)
            }
        }

        return result?.data
    } catch (error) {
        throw new Error(`Error fetching basic metas. URL: ${finalUrl} - ${error}`)
    }
}
